"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var styled_system_1 = require("styled-system");
var Box_1 = require("./Box");
var Input = (0, Box_1.createBasicComponent)((0, styled_system_1.variant)({ scale: 'inputs' }));
Input.defaultProps = {
    variant: 'primary',
    as: 'input'
};
Input.displayName = 'Input';
exports.default = Input;
